import React from 'react';
import logo from '../../logo.svg';
import './starter.css';

/** @jsxImportSource @emotion/react */
import { jsx, css } from '@emotion/react'

// example of string styles
const containerStyle = css`
  background-color: #282c34;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Starter = () => {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
      </header>
    </div>
  );
}

export default Starter;
